import { DefaultOptionType } from 'antd/lib/select';
import { DiseaseOptionV2 } from '@app/components';
import { showDefaultErrorToast } from '@app/utils';
import { useCreateDependent } from '@data/hooks';
import { BehalfOf } from '@data/sdk/match';
import { AntdForm } from '@ui/components';

export type AddDependentFormValues = {
  country: DefaultOptionType;
  diseases?: DiseaseOptionV2[];
  firstName: string;
  haveDisease: boolean;
  lastName: string;
};

export const useAddDependentModal = (onSuccess: () => void) => {
  const [form] = AntdForm.useForm<AddDependentFormValues>();

  const { mutate: createDependent, isPending } = useCreateDependent();

  const handleSubmit = (values: AddDependentFormValues) => {
    createDependent(
      {
        relation: BehalfOf.Child,
        firstName: values.firstName,
        lastName: values.lastName,
        diseases: values.haveDisease ? values.diseases?.map((d) => d.icdCode) ?? [] : [],
        country: values.country.value as string,
      },
      {
        onSuccess: () => {
          form.resetFields();
          onSuccess();
        },
        onError: showDefaultErrorToast,
      },
    );
  };

  return {
    form,
    isPending,
    handleSubmit,
  };
};
